const KEY = "solubail_consent";
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const GA_ID_2 = process.env.REACT_APP_GA4_MEASUREMENT_ID_2;
const META_ID = process.env.REACT_APP_META_PIXEL_ID;
const TWELVE_MONTHS = 365 * 24 * 3600 * 1000;

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { v, t } = JSON.parse(raw);
    if (Date.now() - t > TWELVE_MONTHS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return v;
  } catch {
    return null;
  }
};

export const setConsent = (v) => {
  if (v === null) localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, JSON.stringify({ v, t: Date.now() }));
};

let loaded = false;

export const loadTrackers = () => {
  if (loaded) return;
  loaded = true;

  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
    if (GA_ID_2) window.gtag("config", GA_ID_2);
  }

  if (META_ID) {
    const f = window;
    const d = document;
    if (!f.fbq) {
      const n = (f.fbq = function () {
        if (n.callMethod) n.callMethod.apply(n, arguments);
        else n.queue.push(arguments);
      });
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      const t = d.createElement("script");
      t.async = true;
      t.src = "https://connect.facebook.net/en_US/fbevents.js";
      const sc = d.getElementsByTagName("script")[0];
      sc.parentNode.insertBefore(t, sc);
    }
    window.fbq("init", META_ID);
    window.fbq("track", "PageView");
  }
};
